import { render, staticRenderFns } from "./BaseCoursePicker.vue?vue&type=template&id=26372561&scoped=true&"
import script from "./BaseCoursePicker.vue?vue&type=script&lang=js&"
export * from "./BaseCoursePicker.vue?vue&type=script&lang=js&"
import style0 from "./BaseCoursePicker.vue?vue&type=style&index=0&id=26372561&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26372561",
  null
  
)

export default component.exports